<template>
  <div>
    <v-sheet
      outlined
      min-height="75vh">

      <!-- Imagen para pantallas pequeñas (xs) -->
      <v-img
        class="image-landing"
        height="80"
        v-if="$vuetify.breakpoint.xsOnly && waiting_room_sm_image"
        :src="waiting_room_sm_image"
        max-height="80px"
      ></v-img>

      <!-- Imagen para pantallas medianas y grandes (md y superiores) -->
      <v-img
        class="image-landing"
        height="120"
        v-if="!$vuetify.breakpoint.xsOnly && waiting_room_image"
        :src="waiting_room_image"
        max-height="120px"
      ></v-img>

      <v-row class="pa-8">
        <v-col cols="12" class="pt-8">

          <h3 class="pt-4">
            Hola <b>{{ user.name.toUpperCase() }}</b>... ¡FELICITACIONES!
          </h3>
          
          <p class="pt-4">
            El proyecto <b>{{ convocation_form.convocation_form.title }}</b> HA SIDO APROBADO 
            para participar en la categoría <b>{{ convocation_form.convocation_form.type_postulations.name }}</b> 
            en las <b>{{ edition.edition.short_name }}</b>.
          </p>

          <p> 
            La plataforma se habilitará públicamente a partir del 
            {{ handleDate(edition.edition.start_date_public_access) }}. Por este motivo, 
            ya podés acceder y comenzar a editar la información y cargar los materiales 
            solicitados, incluyendo los integrantes de tu equipo.
          </p>

          <p>
            Ante cualquier consulta, puedes escribir a la organización:
            <a href="mailto:emprendedores@unl.edu.ar">emprendedores@unl.edu.ar</a>
          </p>
          
          <p>
            Quedamos pendientes de lo que se necesite.
          </p>

          <p>
            ¡Saludos!
          </p>

        </v-col>
      </v-row>
      
    </v-sheet>
  </div>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'

  export default {
    name: 'entrepreneurEmpty',
    data: () => ({
      loading:true,
      dialog:false,
      waiting_room_image: null,
      waiting_room_sm_image: null
    }),

    computed: {
      ...mapGetters([
        'isLogged', 'drawer', 'user', 'convocation_form', 'edition'
      ])
    },

    methods:{
      setData(){
        if(this.edition.edition.edition_customization.waiting_room_image!=null){
          this.waiting_room_image = APP_URL + this.edition.edition.edition_customization.waiting_room_image
        }

        if(this.edition.edition.edition_customization.waiting_room_sm_image!=null){
          this.waiting_room_sm_image = APP_URL + this.edition.edition.edition_customization.waiting_room_sm_image
        }
      },

      handleDate(date){
        if(!date){
          return ' -- (fecha a definir)'
        }

        // Split the date into parts
        let parts = date.split("-");
        let year = parts[0];
        let month = parts[1];
        let day = parts[2];
        
        // Rearrange the parts into the desired format
        let formattedDate = `${day}/${month}/${year}`;
        
        return formattedDate;
      }
    },
    created(){
      Promise.all([
        this.setData()
      ]).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.image-landing{
	position: relative;
	max-width: 100vw;
	width: 100%;
  border-bottom: 4px solid #00a1b8;
}
</style>